import React, { useEffect, useState } from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import InputSelect from "../../../components/InputSelect";
import InputDate from "../../../components/InputDate";

import { convertIntToMoney, convertMoenyToInt } from "../../../helpers/conversions";
import { ENTRY_STATUSES, flattenCategories, getCategoryLabel } from "../helpers";
import { usePaymentMethodOptions } from "../../../components/PaymentCondition/usePaymentOptions";

// Filtros avançados da lista de entradas e saídas: estado local hidratado da
// URL ao abrir; "Aplicar"/"Limpar" devolvem para a lista, que navega (padrão
// Product/ModalFilter). O tipo (entrada/saída) fica nas abas da lista, não aqui.
export const ModalFilter = ({ show, close, filters, setCustomFilters, categories, costCenters }) => {
    const [status, setStatus] = useState('');
    const [dueStart, setDueStart] = useState('');
    const [dueEnd, setDueEnd] = useState('');
    const [amountMin, setAmountMin] = useState('');
    const [amountMax, setAmountMax] = useState('');
    const [categoryId, setCategoryId] = useState(null);
    const [costCenterId, setCostCenterId] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const { options: paymentMethodOptions } = usePaymentMethodOptions();

    useEffect(() => {
        if (!show) return;

        setStatus(filters.status);
        setDueStart(filters.dueStart);
        setDueEnd(filters.dueEnd);
        setAmountMin(filters.amountMin ? convertIntToMoney(parseInt(filters.amountMin, 10), true) : '');
        setAmountMax(filters.amountMax ? convertIntToMoney(parseInt(filters.amountMax, 10), true) : '');
        setCategoryId(filters.categoryId || null);
        setCostCenterId(filters.costCenterId || null);
        setPaymentMethod(filters.paymentMethod || null);
    }, [show, filters]);

    // Faixa de valor: guarda centavos na URL; campo vazio ou R$ 0,00 = sem filtro.
    const toCents = masked => {
        const cents = masked ? convertMoenyToInt(masked) : 0;
        return cents > 0 ? String(cents) : '';
    };

    const apply = () => {
        setCustomFilters({
            status,
            dueStart,
            dueEnd,
            amountMin: toCents(amountMin),
            amountMax: toCents(amountMax),
            categoryId: categoryId || '',
            costCenterId: costCenterId || '',
            paymentMethod: paymentMethod || '',
        });
        close();
    };

    const clear = () => {
        setCustomFilters({
            status: '',
            dueStart: '',
            dueEnd: '',
            amountMin: '',
            amountMax: '',
            categoryId: '',
            costCenterId: '',
            paymentMethod: '',
        });
        close();
    };

    // Filtrar por uma sintética traz o que está nas filhas — quem resolve a
    // subárvore é o backend.
    const categoryOptions = flattenCategories(categories).map(category => ({
        label: `${'\u2014 '.repeat(category.depth)}${getCategoryLabel(category)}`,
        value: category.id,
    }));
    const costCenterOptions = costCenters.map(costCenter => ({ label: costCenter.name, value: costCenter.id }));

    return (
        <Modal
            title={`Filtrar títulos`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Limpar filtros`} action={clear} />
                    <Button type={`primary`} size={`small`} text={`Aplicar`} action={apply} />
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col-12">
                        <InputSelect menuInBody label={`Status`} options={[{ label: 'Todos', value: '' }, ...ENTRY_STATUSES]} value={status} change={setStatus} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputDate label={`Vencimento de`} format={`YYYY-MM-DD`} value={dueStart} change={setDueStart} />
                    </div>
                    <div className="col-6">
                        <InputDate label={`Vencimento até`} format={`YYYY-MM-DD`} value={dueEnd} change={setDueEnd} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Valor a partir de`} value={amountMin} change={setAmountMin} mask={`convertToMoney`} />
                    </div>
                    <div className="col-6">
                        <Input label={`Valor até`} value={amountMax} change={setAmountMax} mask={`convertToMoney`} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect menuInBody label={`Categoria`} options={[{ label: 'Todas', value: null }, ...categoryOptions]} value={categoryId} change={setCategoryId} />
                    </div>
                    <div className="col-6">
                        <InputSelect menuInBody label={`Centro de custo`} options={[{ label: 'Todos', value: null }, ...costCenterOptions]} value={costCenterId} change={setCostCenterId} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <InputSelect
                            menuInBody
                            label={`Forma de pagamento`}
                            options={[{ label: 'Todas', value: null }, ...paymentMethodOptions]}
                            value={paymentMethod}
                            change={setPaymentMethod}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalFilter;
